<template>
  
  <div class="todo" ref="container" style="position: relative; width: 100%; height: 100%!important;">
    <!-- Leyenda -->
    <div class="pt-1 ml-5">
      <v-row :style="myStyle" class="mt-1">
        <v-icon :style="tamanoAjustable" color="grey">mdi-circle</v-icon> Apagado
      </v-row>
      <v-row :style="myStyle">
        <v-icon :style="tamanoAjustable" color="orange">mdi-circle</v-icon>En Marcha
      </v-row>
      <v-row :style="myStyle">
        <v-icon :style="tamanoAjustable" color="red">mdi-circle</v-icon>Error
      </v-row>
    </div>
    <canvas ref="canvas" :width="canvasWidth" :height="canvasHeight" style="position: absolute; top: 0; left: 0;"></canvas>
    <div v-if="!ctx">No hay canvas!!!</div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
export default {
  props:{
  },
  data() {
    return {
      animationFrameId:null,
      ctx: null,
      offsetX:0,
      offsetY:0,
      canvasWidth: 0,
      canvasHeight: 0,
      prevWidth: 0,
      prevHeight: 0,
      x1:0,
      x2:100,
      labels:[0,5,10,15,20],
    
    };
  },

  mounted() { 

    this.ctx = this.$refs.canvas.getContext('2d');
    this.updateCanvasSize(); // Inicializar el tamaño del canvas
    this.$nextTick(() => {
      this.dibujarRectangulo(); // Dibujar el rectángulo inicial
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed:{
    ...mapState(['datos_popup']),
    myStyle(){
      return { fontSize:this.canvasWidth/6+'%'}
    },
    tamanoAjustable(){
      return  { fontSize:this.canvasWidth/7+'%'}
    },
    ellipses(){
      let ellipses = [
        // { x: 0, y: 5, id: 9, color: 'white', title: 'Q9', lado:1 },
        { x: 0, y: 1, id: 9, color: 'white', title: 'Q9', lado:1 },
        { x: 0, y: 2, id: 7, color: 'white', title: 'Q7', lado:1 },
        { x: 0, y: 3, id: 5, color: 'white', title: 'Q5', lado:1 },
        { x: 0, y: 4, id: 3, color: 'white', title: 'Q3', lado:1 }, 
        { x: 0, y: 5, id: 1, color: 'white', title: 'Q1', lado:1 },

        { x: 0, y: 1, id: 10,color: 'white', title: 'Q10',lado:2 },
        { x: 0, y: 2, id: 8, color: 'white', title: 'Q8', lado:2 },
        { x: 0, y: 3, id: 6, color: 'white', title: 'Q6', lado:2 },
        { x: 0, y: 4, id: 4, color: 'white', title: 'Q4', lado:2 }, 
        { x: 0, y: 5, id: 2, color: 'white', title: 'Q2', lado:2 },
      ]
      if(this.datos_popup.length > 0){
        let quemadores =  JSON.parse(JSON.stringify(this.datos_popup));
        quemadores = quemadores.filter(e => ['QUEMADOR_1', 'QUEMADOR_2', 'QUEMADOR_3', 'QUEMADOR_4', 'QUEMADOR_5','QUEMADOR_6', 'QUEMADOR_7', 'QUEMADOR_8', 'QUEMADOR_9', 'QUEMADOR_10'].includes(e.name))
        quemadores.map(e => {e.id = e.name.split('_')[1]; return e})
        
        quemadores.forEach(quemador => {
        let elipse = ellipses.find(e => e.id == parseInt(quemador.id))
        if(!elipse){
          console.log("no he encontrado el elipse");
          return
        }
        switch (quemador.value) {
          case 0: // si esta apagado
            elipse.color = 'grey';
            break;
          case 1: // si esta en marcha
            elipse.color = 'orange';
            break;
          case 2: // si esta en error
            elipse.color = 'red';
            break;
          default:
            console.log("Error al recibir el estado del quemador", quemador);
        }
      });

      }
      return ellipses
    }

  },
  methods: {
    dibujarCircunferencias(){

      //Dibujar circunferencias
      const circleCount = 6;
      const circleRadius = Math.min(this.rectWidth, this.rectHeight) * 0.05;
      const circleSpacing = (Math.min(this.rectWidth, this.rectHeight) * 0.8) / circleCount;
      for (let i=0;i < this.ellipses.length;i++){
        const current = this.ellipses[i]
        this.ctx.fillStyle = current.color;
        let circleX = current.x + this.offsetX
        if(current.lado==2) circleX+=this.rectWidth;
        // const circleY = current.y;
        const circleY = this.canvasHeight/6 * current.y
        this.ctx.beginPath();
        this.ctx.arc(circleX, circleY, circleRadius, 0, Math.PI * 2);
        this.ctx.fill();

         // Dibujar el texto centrado en el círculo
        this.ctx.fillStyle =current.color!="white"?'white': 'black'; // Color del texto
        this.ctx.font = '12px Arial'; // Tamaño y tipo de fuente
        this.ctx.textAlign = 'center'; // Alineación horizontal
        this.ctx.textBaseline = 'middle'; // Alineación vertical
        this.ctx.fillText(current.title, circleX, circleY); // Dibuja el texto centrado en el círculo
      }
    },
    dibjarRectaDivisoria(){
 // Coordenadas inicial y final para la línea
      // const startX = this.offsetX;
      // const startY = this.offsetY+150;
      // const endX = this.rectWidth+this.offsetX;
      // const endY = this.rectHeight+this.offsetY-125;
      const startX = this.offsetX;
      const startY = this.canvasHeight/12*5
      const endX = this.rectWidth+this.offsetX;
      const endY = this.canvasHeight/12*7
      // Configuración del trazo
      this.ctx.beginPath();
      this.ctx.moveTo(startX, startY); // Mover el cursor al punto inicial
      this.ctx.lineTo(endX, endY); // Dibujar una línea hasta el punto final
      this.ctx.strokeStyle = '#000000'; // Color de la línea (negro en este caso)
      this.ctx.lineWidth = 2; // Ancho de la línea
      this.ctx.stroke(); // Dibujar la línea


       // Configurar el estilo de texto
      this.ctx.font = '24px Arial';
      this.ctx.fillStyle = '#000';
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';


      const textoSuperior = 'Z2';
      const textoInferior = 'Z1';

      const tercioAltura = this.canvasHeight / 3; // Un tercio de la altura

      // Dibujar texto en la mitad superior
      this.ctx.fillText(textoSuperior, this.canvasWidth / 2, tercioAltura);

      // Dibujar texto en la mitad inferior
      this.ctx.fillText(textoInferior, this.canvasWidth/ 2, tercioAltura * 2);

      //Dibujar texto parte inferior
      this.ctx.fillText('Puerta',this.offsetX + this.rectWidth/2, this.offsetY + this.rectHeight - 10);
    },
    dibujarRectangulo() {
      this.ctx.clearRect(0, 0, this.prevWidth, this.prevHeight); // Limpiar el área anterior completamente
      this.ctx.strokeStyle = 'black';
      this.ctx.lineWidth = 2;

      this.offsetX = this.canvasWidth * 0.2;
      this.offsetY = this.canvasHeight * 0.01;
      this.rectWidth = this.canvasWidth - (2 * this.offsetX);
      this.rectHeight = this.canvasHeight - (2 * this.offsetY);

      this.ctx.strokeRect(this.offsetX, this.offsetY, this.rectWidth, this.rectHeight);

      //Dibujar recta divisoria de zonas
      this.dibjarRectaDivisoria();

     this.dibujarCircunferencias();


    },
    updateCanvasSize() {
      const container = this.$refs.container;
      this.prevWidth = this.canvasWidth; // Almacenar el tamaño anterior del canvas
      this.prevHeight = this.canvasHeight;
      this.canvasWidth = container.clientWidth;
      this.canvasHeight = container.clientHeight>100?container.clientHeight:100
      cancelAnimationFrame(this.animationFrameId);

      this.animationFrameId = requestAnimationFrame(() => {
        this.dibujarRectangulo(); // Volver a dibujar el rectángulo al redimensionar
      });
    },
    handleResize() {
      // Manejar el redimensionamiento de la ventana
      this.updateCanvasSize();
    },
  },
  watch:{
    ellipses: {
      immediate: true,
      deep: true,
      handler(newVal) {
          this.$nextTick(() => {
            this.dibujarRectangulo(); // Dibujar el rectángulo inicial
          });
      }
    }
  }
};
</script>

<style scoped>
.todo {
  background-color: rgba(102, 51, 153, 0.116);
  width: 100%;
  height: 100%;
}
.texto_adaptable{
  font-size: 90%;
}
</style>
